import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageAdd"><Path d="M8 3H3V21H12V14H15V11H21V3H16V9H8V3Z" fill="currentColor"/><Path d="M14 3H10V7H14V3Z" fill="currentColor"/><Path d="M19 16V13H17V16H14V18H17V21H19V18H22V16H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageAdd;
